export default {
  cancelingInstructions: {
    chapter: '1',
    component: 'helmi-section',
    props: {
      label: 'Peruuttamislomake',
    },
    children: {
      instructions1: {
        chapter: '1',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Peruuttamisoikeus (Kuluttajansuojalaki 6 luku (30.12.2013/1211) (Kotimyynti ja etämyynti)',
          hint: `Teillä on oikeus peruuttaa tämä sopimus 14 päivän kuluessa syytä ilman erityistä syytä. Peruuttamisen määräaika
päättyy 14 päivän kuluttua sopimuksen tekemisestä. Peruuttamisoikeuden käyttämiseksi teidän on ilmoitettava meille
päätöksestänne peruuttaa sopimus yksiselitteisellä tavalla (esimerkiksi kirjeellä postitse, tai sähköpostilla). Voitte käyttää
alla olevaa peruuttamislomaketta, mutta sen käyttö ei ole pakollista. Postiosoitteemme löydätte
toimeksiantosopimuksesta.`,
        },
      },
      instructions2: {
        chapter: '2',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Peruuttamisen vaikutukset',
          hint: `Jos olette pyytänyt palvelun suorittamista ennen peruuttamisajan päättymistä, teidän on maksettava meille
          peruuttamisilmoituksen tekemiseen mennessä sopimuksen täyttämiseksi tehdystä suorituksesta kohtuullinen korvaus.`,
        },
      },
      receiverName: {
        chapter: '3.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 4,
        },
        props: {
          label: 'Vastaanottajan nimi',
          type: 'text',
        },
        value: null,
      },
      receiverAddress: {
        chapter: '3.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 4,
        },
        props: {
          label: 'Vastaanottajan osoite',
          type: 'text',
        },
        value: null,
      },
      receiverPhone: {
        chapter: '3.3',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 4,
        },
        props: {
          label: 'Vastaanottajan sähköpostiosoite',
          type: 'text',
        },
        value: null,
      },
      form: {
        chapter: '3.4',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Peruutuksen tiedot',
          hint: `Ilmoitan / Ilmoitamme*, että haluan / haluamme* peruuttaa tekemäni/tekemämme* sopimuksen, joka koskee seuraavien tavaroiden toimittamista* / seuraavan palvelun suorittamista*:


Tilauspäivä* / Vastaanottopäivä*


Kuluttajan nimi* / Kuluttajien nimet*


Kuluttajan osoite* / Kuluttajien osoitteet*


Paikka ja aika:


Kuluttajan allekirjoitus* / Kuluttajien allekirjoitukset*






* Tarpeeton yliviivataan.`,
        },
      },
    },
  },
};
